var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58651 11.8339C5.19815 12.0921 4.67001 12.0493 4.32795 11.7056L0.29299 7.65071C-0.0976631 7.25812 -0.0976635 6.62162 0.29299 6.22904C0.683643 5.83645 1.31702 5.83645 1.70767 6.22904L5.04729 9.58515L14.2923 0.294437C14.683 -0.0981458 15.3164 -0.0981458 15.707 0.294437C16.0977 0.687021 16.0977 1.32352 15.707 1.71611L5.80424 11.6678C5.73787 11.7345 5.6645 11.7899 5.58651 11.8339Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.8f648fe21e70b178508c9a8cbd95dfd2.svg";
export { ForwardRef as ReactComponent };